import styled from 'styled-components'
import { GUIDE_STYLED_PROPS } from './interface'

export const GuideContainer = styled.div<GUIDE_STYLED_PROPS>`
  border-radius: 9px;
  padding: 12px;
  width: 345px;
  min-height: 175px;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
  top: 0;
  right: 50%;
  transform: translateX(50%);
  background: ${({ colors }) =>
    colors ? colors.primaryBackground : 'rgba(0,0,0,0.77)'};
  color: ${({ colors }) => (colors ? colors.primaryText : '#ffb000')};
  opacity: ${({ anim }) => (anim ? 1 : 0)};
  transition: opacity 0.5s;
`
export const Header = styled.div<GUIDE_STYLED_PROPS>`
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  text-align: center;
  font-size: 12px;
  svg {
    cursor: pointer;
  }
`
export const Content = styled.div<GUIDE_STYLED_PROPS>`
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.33);
  min-height: 100px;
  color: #ffffff;
  h2 {
    font-size: 16px;
    text-transform: uppercase;
    opacity: ${({ anim }) => (anim ? 1 : 0)};
    transition: opacity 0.5s;
  }
  p {
    font-size: 12px;
    line-height: 1.8;
    opacity: ${({ anim }) => (anim ? 1 : 0)};
    transition: opacity 0.5s;
  }
`
export const Footer = styled.div<GUIDE_STYLED_PROPS>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  span {
    font-size: 12px;
    color: #ffffff;
  }
  p {
    font-size: 16px;
    text-transform: uppercase;
    cursor: pointer;
  }
`
export const Arrow = styled.div<GUIDE_STYLED_PROPS>`
  position: absolute;
  width: 10px;
  height: 10px;
  z-index: 1;
  background: ${({ colors }) =>
    colors ? colors.primaryBackground : 'rgba(0,0,0,0.5)'};
  border-radius: 2px;
  transform: rotate(45deg);
  opacity: ${({ anim }) => (anim ? 1 : 0)};
  ${({ positionY, guideHeight }) =>
    positionY === 'bot'
      ? `bottom: calc(100% -  ${guideHeight}px - 5px);`
      : 'top: -5px;'}
  left:  ${({ positionX }) =>
    positionX === 'left' ? `5%` : positionX === 'right' ? '46%' : '92%'};
`
